import { useEffect, useState } from 'react';

// Msal imports
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import {
  InteractionStatus,
  InteractionType,
  InteractionRequiredAuthError,
  AccountInfo,
} from '@azure/msal-browser';
import { loginRequest } from '../components/Auth/authConfig';

// Sample app imports
import { ProfileData, GraphData } from '../components/ProfileData';
import { Loading } from '../components/Loading';
import { ErrorComponent } from '../components/ErrorComponent';
import { callMsGraph } from '../apis';
import { Text } from '@flixbus/honeycomb-react';

const ProfileContent = () => {
  const { instance, inProgress } = useMsal();
  const [graphData, setGraphData] = useState<null | GraphData>(null);

  useEffect(() => {
    if (!graphData && inProgress === InteractionStatus.None) {
      callMsGraph()
        .then(response => setGraphData(response))
        .catch(e => {
          if (e instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect({
              ...loginRequest,
              account: instance.getActiveAccount() as AccountInfo,
            });
          }
        });
    }
  }, [inProgress, graphData, instance]);

  return <Text>{graphData ? <ProfileData graphData={graphData} /> : null}</Text>;
};

export function Profile() {
  const authRequest = {
    ...loginRequest,
  };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <ProfileContent />
    </MsalAuthenticationTemplate>
  );
}
